import React from 'react';
import { CheckCircleIcon, MicIcon, FileTextIcon } from 'lucide-react';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SecondaryButton } from '../ui/SecondaryButton';
export function Screen11_PTPCreated({
  data,
  onNext,
  onBack
}: ScreenProps) {
  return <div className="flex flex-col h-full" data-id="element-341">
      <div className="mb-6" data-id="element-342">
        <h2 className="text-2xl font-bold text-white mb-2" data-id="element-343">PTP Created</h2>
        <p className="text-slate-400" data-id="element-344">
          The plan is ready. Next, record the crew PTP meeting to verify
          understanding and capture additional safety information.
        </p>
      </div>

      <div className="flex-1 overflow-y-auto pb-6 -mx-2 px-2 space-y-6" data-id="element-345">
        {/* PTP Status Card */}
        <div className="bg-slate-900 border border-slate-800 rounded-xl p-5 relative overflow-hidden" data-id="element-346">
          <div className="absolute top-0 right-0 bg-green-500/20 text-green-400 text-xs font-bold px-3 py-1 rounded-bl-lg flex items-center gap-1" data-id="element-347">
            <CheckCircleIcon className="w-3 h-3" data-id="element-348" />
            PTP Ready
          </div>

          <div className="space-y-4 mt-2" data-id="element-349">
            <div data-id="element-350">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-351">
                Project
              </p>
              <p className="text-white font-medium text-sm" data-id="element-352">{data.project}</p>
            </div>
            <div data-id="element-353">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-354">
                Location
              </p>
              <p className="text-white font-medium text-sm" data-id="element-355">{data.location}</p>
            </div>
            <div data-id="element-356">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-357">
                Task
              </p>
              <p className="text-orange-400 font-bold text-sm" data-id="element-358">
                Steel Beam Installation Using Mobile Crane
              </p>
            </div>
          </div>
        </div>

        {/* Info Section */}
        <div className="bg-slate-900/50 border border-slate-800/50 rounded-xl p-5" data-id="element-359">
          <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" data-id="element-360">
            Why record the meeting?
          </h3>
          <ul className="space-y-3" data-id="element-361">
            {['Confirm the crew understands the plan', 'Capture additional risks discussed in the field', 'Verify who participated in the briefing', 'Score meeting quality and coverage'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-362">
                <div className="w-1.5 h-1.5 rounded-full bg-orange-500 mt-1.5 flex-shrink-0" data-id="element-363" />
                <span className="text-slate-300 text-sm leading-snug" data-id="element-364">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="pt-4 space-y-3 bg-slate-950" data-id="element-365">
        <PrimaryButton onClick={onNext} icon={<MicIcon className="w-5 h-5" data-id="element-367" />} data-id="element-366">
          Start PTP Meeting Recording
        </PrimaryButton>
        <SecondaryButton onClick={onBack} icon={<FileTextIcon className="w-5 h-5" data-id="element-369" />} data-id="element-368">
          View PTP Summary
        </SecondaryButton>
      </div>
    </div>;
}